<template>
    <section class="db">
        <h2 class="section-title">
            {{ $t("База знаний") }}
        </h2>
        <v-layout wrap row d-flex>
            <router-link v-for="(item, index) in accessed_items" :key="index" :to="{name: 'database', hash: item.hash}"
                         class="db-card__link d-flex md3 xs6"
            >
                <CardBgIcon type='right' :text="item.text" :icon_name='item.icon'
                            :class="item.iconClass"
                />
            </router-link>
        </v-layout>
    </section>
</template>

<script>
import CardBgIcon from '@/components/ui/buttons/card_bg_icon/card_bg_icon_wrapper';
import {mapGetters} from 'vuex';
import REGION_CODES from '@/configs/region_codes';
export default {
  components: {
    CardBgIcon,
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    ...mapGetters('profile/user', [
      'user',
    ]),
    accessed_items() {
      return this.items.filter((item) => item.permission);
    },
  },
  mounted() {
    this.items = [
      {
        text      : this.user.region_code !== REGION_CODES.BITUM_MATERIALS ? this.$t('Международные классификации') : this.$t('Методические материалы'),
        icon      : this.user.region_code !== REGION_CODES.BITUM_MATERIALS ? 'icon-list' : 'oil-truck',
        hash      : '#classification',
        iconClass : 'db-red layout',
        permission: true,
      },
      {
        text      : this.$t('Спецификации ОЕМ'),
        icon      : 'approval',
        hash      : '#oem',
        iconClass : 'db-green',
        permission: this.user.region_code !== REGION_CODES.BITUM_MATERIALS,
      },
      {
        text      : this.$t('Продуктовый портфель'),
        icon      : 'portfolio',
        hash      : '#products',
        iconClass : 'db-grey',
        permission: this.user.region_code !== REGION_CODES.BITUM_MATERIALS,
      },
      {
        text      : this.$t('Глоссарий'),
        hash      : '#glossary',
        icon      : 'info',
        iconClass : 'db-info',
        permission: this.user.region_code !== REGION_CODES.BITUM_MATERIALS,
      },
    ];
  },
};
</script>

<style>

</style>
